import { toast } from 'react-toastify';

/**
 * Copy text to clipboard and show a toast notification
 */
export const copyToClipboard = async (
	text: string,
	message: string = 'Copied to clipboard',
): Promise<boolean> => {
	try {
		await navigator.clipboard.writeText(text);
		toast.success(message, { autoClose: 2000 });

		return true;
	} catch (error) {
		// console.error('Failed to copy to clipboard:', error);
		toast.error('Failed to copy to clipboard');
		return false;
	}
};

/**
 * Copy account address to clipboard
 */
export const copyAccountAddress = async (address: string): Promise<boolean> => {
	return copyToClipboard(address, 'Account address copied');
};
